import React from 'react'
import PropTypes from 'prop-types'
import Badge from '@piconetworks/badge'
import classNames from 'classnames'
import { getSvgImage } from '@piconetworks/functions'

import styles from './Launcher.module.scss'

const IconButton = ({
    buttonClick,
    publisherName,
    publisherIcon,
    warnings,
    showCloseIcon,
    linkColor,
}) => {
    const warningType = Object.keys(warnings).reduce((acc, warning) => {
        const warningStatus = warnings[warning]

        if (warningStatus || acc) {
            return warning
        }

        return acc
    }, false)

    const showWarning = !!warningType && !showCloseIcon

    return (
        <div className={styles.iconButtonContainer}>
            <Badge
                className={styles.badge}
                topRightLabel={showWarning && (
                    <span style={{ fontSize: '24px' }} className="icon-icon_warning" />
                )}
                variant={showWarning ? 'warning' : ''}
            >
                <button
                    type="button"
                    onClick={() => {
                        buttonClick(warningType)
                    }}
                    className={classNames(
                        styles.iconButton,
                    )}
                    style={{
                        backgroundColor: linkColor,
                    }}
                >
                    <img
                        alt={publisherName}
                        className={classNames(
                            styles.iconImage,
                            {
                                [styles.iconImageClosed]: showCloseIcon,
                            },
                        )}
                        src={publisherIcon}
                    />
                    <div className={classNames(
                        styles.closeIconContainer,
                        {
                            [styles.showCloseIcon]: showCloseIcon,
                        },
                    )}
                    >
                        {getSvgImage('#FFF', 'close-icon')}
                    </div>
                </button>
            </Badge>
        </div>
    )
}

IconButton.defaultProps = {
    buttonClick: () => {},
    publisherName: null,
    publisherIcon: null,
    showCloseIcon: false,
    linkColor: 'rgb(122, 52, 255)',
    warnings: {
        userNotVerified: false,
    },
}

IconButton.propTypes = {
    buttonClick: PropTypes.func,
    publisherName: PropTypes.string,
    publisherIcon: PropTypes.string,
    showCloseIcon: PropTypes.bool,
    linkColor: PropTypes.string,
    warnings: PropTypes.shape({
        userNotVerified: PropTypes.bool,
    }),
}

export default IconButton
